<template slot="allocations" slot-scope="props">
  <tr
    style="cursor: pointer"
    :class="{ 'cyan lighten-5': !!allocation.docketId || !!allocation.prelimDocketId, 'green lighten-5' : newAllocation, 'grey lighten-3': allocation.void }"
    @click="detailDialog = true"
  >
    <td @click.stop>
      <v-checkbox
        v-model="selected"
        :color="$store.state.global.pages.allocation.color"
        hide-details
      ></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span
        v-if="header.type == 'count'"
      >{{ getObjectPath(header.value, allocation).length || "-" }}</span>
      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, allocation)) || "-" }}</span>
      <span
        v-if="header.type == 'time'"
      >{{ makeTime(getObjectPath(header.value, allocation)) || "-" }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ displayDecimal(getObjectPath(header.value, allocation),header.decimals) || "-" }}</span>
      <span
        v-if="header.type == 'curr' "
      >{{ !!getObjectPath(header.value, allocation) ? `$ ${displayDecimal(getObjectPath(header.value, allocation),header.decimals)}` : "-" || "" }}</span>
      <span
        v-if="header.type == 'text'"
      >{{ !!getObjectPathRootExists(header.value, allocation) ? getObjectPath(header.value, allocation) : "-" || "-" }}</span>
      <span v-if="header.type == 'dayBool'">
        <v-icon v-if="getObjectPath(header.value, allocation)" color="amber darken-1">wb_sunny</v-icon>
        <v-icon v-else color="blue-grey darken-3">nights_stay</v-icon>
      </span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile
              v-if="!allocation.docketId && $store.state.user.userAuthClass.allowDocketEntry && !allocation.void"
              title="Create Docket From..."
              :color="$store.state.global.pages.docket.color"
              :icon="$store.state.global.pages.allocation.icon"
              :onClick="createDocketFrom"
            ></basic-list-tile>
            <basic-list-tile
              :title="allocation.void ? 'Details' : 'Edit'"
              icon="edit"
              :onClick="editAllocation"
              v-if="userAuthClass"
            ></basic-list-tile>
            <basic-list-tile
              title="VOID"
              icon="block"
              :onClick="openVoidDialog"
              v-if="userAuthClass && !allocation.void"
            ></basic-list-tile>
            <basic-list-tile
              color="red lighten-3"
              title="Delete"
              icon="delete"
              :onClick="openDeleteDialog"
              v-if="userAuthClass && !allocation.void"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->

    <!-- Allocation edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-allocation @close="editDialog = false" :allocation="allocation"></edit-allocation>
    </v-dialog>

    <!-- VOID ALLOCATION DIALOG -->
    <v-dialog lazy v-model="voidDialog" max-width="700px" @keydown.esc="voidDialog = false">
      <v-card>
        <v-card-title class="headline">
          <span>
            Really VOID?
            <span class="grey--text subheading">- {{allocation.id}}</span>
          </span>
        </v-card-title>
        <v-card-text class="py-0">
          <v-textarea auto-grow label="Notes" rows="2" v-model="voidNotes"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="voidDialog = false">Cancel</v-btn>
          <v-btn color="grey darken-1" flat :loading="loading" @click="voidAllocation()">VOID</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Allocation Detail dialog -->
    <!-- <v-dialog lazy v-model="detailDialog" max-width="700px" @keydown.esc="detailDialog = false">
            <allocation-detail :allocation="allocation" @seeDocketDetails="detailDialog = false; allocationDialog = true"></allocation-detail>
    </v-dialog>-->

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog lazy v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{allocation.id}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat :loading="loading" @click="deleteAllocation()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </tr>
</template>

<script>
import EditAllocation from '@/components/allocations/editAllocation'
import FormatDates from '@/services/mixins/formatDates'
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'
import DocketService from '@/services/requests/docketService'

import RowDisplayMethods from '@/services/mixins/rowDisplayMethods'
export default {
  mixins: [FormatDates, RowDisplayMethods],
  data() {
    return {
      editDialog: false,
      voidDialog: false,
      detailDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      allocationDialog: false,
      actionsMenu: false,
      newAllocation: this.allocation.new,
      loading: false,
      voidNotes: ''
    }
  },
  methods: {
    actionComplete() {
      this.fieldData = {}
      this.actionConfirmationDialog = false
    },
    openVoidDialog() {
      this.voidDialog = true
    },
    openDeleteDialog() {
      this.deleteDialog = true
    },
    voidAllocation() {
      this.loading = true
      const payload = {
        id: this.allocation.id,
        voidNotes: this.voidNotes
      }
      AllocationService.voidAllocation(payload)
        .then(result => {
          if (this.showVoid) {
            this.$store.commit('allocations/updateArrayStateByValue', {
              prop: 'allocations',
              value: this.allocation,
              editedValue: result.data.result.allocation
            })
          } else {
            this.$store.commit('allocations/deleteFromArrayStateByValue', {
              prop: 'allocations',
              value: this.allocation
            })
          }

          this.snack({ text: 'Allocation was made VOID!', color: 'green' })
          this.loading = false
          this.voidDialog = false
        })
        .catch(err => {
          this.loading = false
          this.snackError()
        })
    },
    deleteAllocation() {
      this.loading = true
      AllocationService.deleteAllocation(this.allocation.id)
        .then(result => {
          this.$store.commit('allocations/deleteFromArrayStateByValue', {
            prop: 'allocations',
            value: this.allocation
          })
          this.snack({ text: 'Allocation was deleted!', color: 'yellow' })
          this.loading = false
          this.deleteDialog = false
        })
        .catch(err => {
          //console.log("An error occured");
          this.loading = false
          this.snackError()
        })
    },
    editAllocation() {
      this.editDialog = true
    },
    createDocketFrom() {
      //console.log('Create docket from allocation');
      this.$emit('createDocketFromAllocation', this.allocation)
      //this.allocationDialog = true
    },
    confirmUpdateAllocationField(payload) {
      this.fieldData = payload
      this.currentNotes = this.allocation[payload.notesField]
      this.actionConfirmationDialog = true
    }
  },
  computed: {
    showVoid: Store.getSet({ store: 'allocations', prop: 'showVoid' }),
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', { value: val, object: this.allocation })
      }
    }
  },
  mounted() {
    if (this.allocation.new) {
      setTimeout(() => {
        this.newAllocation = false
      }, 10000)
    }
  },
  props: {
    allocation: Object,
    headers: Array,
    value: Boolean
  },
  components: {
    EditAllocation
  }
}
</script>

<style>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}
</style>
